module.exports = __webpack_public_path__ + "static/2-ordenamiento-silvestre-68f058ab50f11bfa647c63a2ae65c182.jpg";